import bcrypt from 'bcryptjs';
import { useStoreState } from '@/stores/store';
import { useCallback, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import PasswordGesture from '../';
import colors from '@/config/colors';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

export default function CheckPassword({ route }) {
  const navigation = useNavigation();
  const [state, setState] = useState({
    message: 'Sperrmuster eingeben',
    status: 'normal',
  });
  const { PASSWORD, downloadPatients } = useStoreState((store) => ({
    PASSWORD: store.appLockPattern,
    downloadPatients: store.downloadPatients,
  }));
  const { showNotification } = useNotification();
  const { setShowHeader } = useSidebarAnimation();
  const [unlocked, setUnlocked] = useState(false);

  useFocusEffect(
    useCallback(() => {
      return navigation.addListener('beforeRemove', (e) => {
        if (!unlocked) {
          e.preventDefault();
        } else {
          navigation.dispatch(e.data.action);
        }
      });
    }, [navigation, unlocked]),
  );

  function onEnd(password) {
    if (bcrypt.compareSync(password, PASSWORD)) {
      setUnlocked(true);

      const routes = navigation.getState().routes;
      const prevRoute = routes[routes.length - 2];
      const beforePrevRoute = routes[routes.length - 3];

      // This timeout is necessary to trigger the navigation reset after the state update
      // without it, the navigation to the Home screen doesn't work on all devices.
      setTimeout(() => {
        if (route.params?.blockBackFromSelfTraining) {
          const getLatestSelfTrainingParams = () => {
            return (
              routes.findLast((r) => r.name === 'SelfTraining')?.params ?? {}
            );
          };
          navigation.navigate('PatientProfile', {
            id: getLatestSelfTrainingParams().selectedPatient?._id,
            patients: downloadPatients,
          });
        } else if (prevRoute && prevRoute.name !== 'Privacy') {
          navigation.goBack();
        } else if (
          prevRoute &&
          prevRoute.name === 'Privacy' &&
          beforePrevRoute
        ) {
          navigation.navigate(beforePrevRoute.name, beforePrevRoute.params);
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: 'Home' }],
          });
        }
      });
    } else {
      setUnlocked(false);
      setState({
        status: 'wrong',
        message: 'Sperrmuster ist falsch, versuchen Sie es erneut',
      });
    }
  }

  function onStart() {
    setState({
      status: 'normal',
      message: 'Sperrmuster eingeben',
    });
  }

  useFocusEffect(() => {
    setShowHeader(false);

    return () => {
      setShowHeader(true);
    };
  });

  return (
    <View style={styles.container}>
      <View style={{ maxHeight: 360, flex: 1 }}>
        <PasswordGesture
          status={state.status}
          message={state.message}
          onStart={() => onStart()}
          onEnd={(password) => onEnd(password)}
          innerCircle={true}
          outerCircle={true}
          showNotification={showNotification}
        />
        <View style={styles.btnContainer}>
          <PressableNeolexon
            onPress={() => {
              navigation.navigate('PasswordUnlock');
              setShowHeader(false);
            }}
            style={styles.flexOne}
          >
            <Text style={styles.text}>Sperrmuster vergessen?</Text>
          </PressableNeolexon>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    backgroundColor: colors.black,
    paddingTop: Platform.OS === 'web' ? '12%' : 0,
  },
  btnContainer: {
    flexDirection: 'row',
    width: '100%',
    backgroundColor: colors.black,
    paddingBottom: 10,
  },
  flexOne: {
    flex: 1,
  },
  text: {
    textAlign: 'center',
    fontWeight: '700',
    paddingVertical: 10,
    fontSize: 16,
    color: colors.white,
  },
});
